import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";
import ButtonNormal from '../../../components/Buttons/ButtonNormal';
import {
    FormControl,
    FormLabel,
    FormControlLabel,
    FormHelperText,
    RadioGroup,
    Radio,
  } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
      },
      TextField: {
        maxWidth: '100%',
        height: 74
      },
      rootFormwith:{
        maxWidth: '100%',
        padding: '0 16px'
      }, 
    formHelperText: {
        margin: '8px 14px 0px 14px',
    },
    textLabel:{
        margin: '0 0 16px 0',
    },
    textValid:{
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#10587f',
        marginTop: 16
    },
    space:{
        justifyContent: 'space-between',
    },
    label: {
        '@media screen and (max-width: 500px)': {
            marginRight: 0,
        }
    }
  }));

 
  const LandingForm = (props) => {
    const classes = useStyles();

    const {
        values:{name,email, phone, gender}
        ,handleSubmit,handleChange,setFieldValue,
        touched,dirty,handleBlur,errors,isValid,
    } = props;

    const handleChangeMultiple = field => event => {
        event.preventDefault();
        let value = event.target.value;
        setFieldValue(field, value);
    };
    
    return ( 
        <div style={{display:'flex',    
        flexDirection: 'column', width: '100%',marginTop:16,
        alignItems: 'center'}}>

            <TextField
                label="Nombre"
                type="text"
                id="name"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={name}
                helperText={touched.name && errors.name ? errors.name : ''}
                error={touched.name && errors.name ? true : false}
            />

            <TextField
                label="Email"
                type="email"
                id="email"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={email}
                helperText={touched.email && errors.email ? errors.email : ''}
                error={touched.email && errors.email ? true : false}
            />

            <TextField
                label="Teléfono"
                type="text"
                id="phone"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={phone}
                helperText={touched.phone && errors.phone ? errors.phone : ''}
                error={touched.phone && errors.phone ? true : false}
            />
                <FormControl
                    error={touched.gender && errors.gender ? true : false}
                    component="fieldset"  className={classes.rootFormwith}
                >
                <div className={classes.rootFormControl}>
                    <FormLabel component="legend" className={classes.textLabel}>
                        Tipo de negocio
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-label="gender"
                        name="gender"
                        classes={{root : classes.space}}
                        value={gender}
                        onChange={handleChangeMultiple('gender')}
                        onBlur={handleBlur}
                    >
                        <FormControlLabel
                            value="despacho"
                            control={<Radio color="secondary" />}
                            label="Despacho/firma"
                            classes={{ root: classes.label }}
                        />
                        <FormControlLabel
                            value="abogado"
                            control={<Radio color="secondary"/>}
                            label="Independiente"
                            classes={{ root: classes.label }}
                        />
                    </RadioGroup>
                </div>
                {touched.gender && errors.gender ? (
                    <FormHelperText
                        color="error"
                        classes={{ root: classes.formHelperText }}
                    >
                        {errors.gender}
                    </FormHelperText>
                ) : (
                    ''
                )}
                </FormControl>
                <div style={{ width: '90%', marginTop: 28 , display: 'flex' ,flexDirection: 'column', alignItems: 'center'}}>
                    <ButtonNormal
                        type="submit"
                        onClick={handleSubmit}
                        variant="secondary"
                        disabled={!isValid}
                        classes={{ root: classes.otro }}
                        >
                        ¡Obtén tu membresía!
                    </ButtonNormal>
                </div>
               

        
    </div>
     );
}
 
export default LandingForm;